const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const pad = (n) => (n < 10 ? '0' + n : n)

// "dd-mm-yyyy hh:mm:ss Weekday" — används i: AdminSupport.js, Overview.js, Support.js
export const getDateTimeWithWeekday = () => {
  const d = new Date()
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())} ${WEEKDAYS[d.getDay()]}`
}

// "dd-mm-yyyy hh:mm am/pm" — används i: AdminUpload.js
export const getDateTimeWithAmPm = () => {
  const d = new Date()
  const hour = d.getHours()
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(hour)}:${pad(d.getMinutes())} ${hour >= 12 ? 'pm' : 'am'}`
}

// "yyyy-mm-dd hh:mm" — används i: BuyCredit.js
export const getDateTime = () => {
  const d = new Date()
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

// "dd-mm-yyyy" — används i: Upload.js
export const getDateOnly = () => {
  const d = new Date()
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`
}
